module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_365_730.70178c33.png";